import { axios } from '../base/bootstrap';

import AbstractApi from './AbstractApi';

export default abstract class AbstractSiteApi extends AbstractApi {
    protected apiPrefix: string = '/site/api/';

    protected endpoint: string = '';

    protected getAxios = () => axios;
}
